"use client";

import { useContext, useEffect } from "react";
import { useSearchParams } from "next/navigation";

import { setAuthCookie, setCookie, decodeToken } from "@/services/CookiesService";
import { UserContext } from "@/contexts/UserContext";

import { UTMS } from "./types";

export const StoreUtms = () => {
  const searchParams = useSearchParams();
  const userContext = useContext(UserContext);

  const UTM_SOURCES = [
    "utm_source",
    "utm_campaign",
    "utm_medium",
    "gclid",
    "msclkid",
    "tag",
    "utm_term",
    "utm_content",
    "utm_adgroup",
    "utm_network",
    "utm_device",
    "utm_devicemodel",
    "utm_matchtype",
    "utm_loc_physical_ms",
    "utm_campaigntype",
  ];

  useEffect(() => {
    const keys = searchParams.keys();
    const utmsMatchQueryParams = {};

    for (const key of keys) {
      if (UTM_SOURCES.includes(key)) {
        utmsMatchQueryParams[key] = searchParams.get(key);
      }
      if (key === "token") {
        const tokenValue = searchParams.get(key);

        if (tokenValue) {
          if (userContext?.user) {
            const { email, id } = decodeToken(tokenValue) as any;

            userContext.setUser({
              ...userContext.user,
              email,
              userId: id,
            });
          }

          setAuthCookie(tokenValue);
        }
      }
    }

    if (Object.keys(utmsMatchQueryParams).length !== 0) {
      setCookie(UTMS, utmsMatchQueryParams);
    }
  }, []);

  return null;
};
